import firebase from "../firebase/firebase";
import "firebase/firestore";
import utils from "../utils";
const db = firebase.firestore();

class UserStore {
  constructor(collectionName) {
    this.collectionName = collectionName;
    this.staticUsers = {
      "9x0ts4uGfp2Iy3Nq7oOb": {
        id: "9x0ts4uGfp2Iy3Nq7oOb",
        role: "center_manager",
        name: "Sudheer",
        email: "sudheernirmaan@gmail.com",
        password: "123"
      },
      K1iWFoQE7PpBoAQW8wuv: {
        id: "K1iWFoQE7PpBoAQW8wuv",
        role: "partner",
        name: "uma Kesani",
        email: "uma.kesani@gmail.com",
        password: "123"
      },
      nY2thD00rsgRxzdlLFFi: {
        id: "nY2thD00rsgRxzdlLFFi",
        role: "donor",
        name: "Colruyt",
        email: "colruyt@gmail.com",
        password: "123"
      }
    };
  }

  async getUsers(model) {
    let items = [];
    try {
      const snapshot = await db.collection(this.collectionName).get();
      snapshot.forEach(doc => {
        model = Object.assign({}, doc.data());
        model.Id = doc.id;
        items.push(model);
      });
      return items;
    } catch (err) {
      console.log("error", err);
    }
  }
  /* 
  getUsers(model) {
    var users = [];
    var usersCollection = db.collection(this.collectionName);
    var dbModel = model;
    return new Promise(function(resolve, reject) {
      usersCollection
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            //console.log(doc.id, ' => ', doc.data())
            dbModel = Object.assign({}, doc.data());
            dbModel.Id = doc.id;
            users.push(dbModel);
          });
        })
        .catch(function(error) {
          reject(error);
        });
      resolve(users);
    });
  } */

  getUser(Id, model) {
    var usersCollection = db.collection(this.collectionName);
    var dbModel = model;
    return new Promise(function(resolve, reject) {
      var docRef = usersCollection.doc(Id);
      docRef
        .get()
        .then(doc => {
          //console.log(doc.id, ' => ', doc.data())
          dbModel = Object.assign({}, doc.data());
          dbModel.Id = doc.id;
          resolve(dbModel);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  addUser(model) {
    //console.log(model)
    var json = utils.mapDatabaseFields(model);
    var collection = this.collectionName;
    var response = { isSaved: false, error: "" };

    return new Promise(function(resolve, reject) {
      db.collection(collection)
        .add(json)
        .then(function() {
          response.isSaved = true;
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  updateUser(model) {
    //console.log(model)
    var json = utils.mapDatabaseFields(model);
    var collection = this.collectionName;
    var response = { isUpdated: false, error: "" };

    return new Promise(function(resolve, reject) {
      var docRef = db.collection(collection).doc(model.Id);
      docRef
        .update(json)
        .then(function() {
          response.isUpdated = true;
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  deleteUser(model) {
    var collection = this.collectionName;
    var response = { isDeleted: false, error: "" };

    if (model.Id != null) {
      return new Promise(function(resolve, reject) {
        var docRef = db.collection(collection).doc(model.Id);
        docRef
          .delete()
          .then(function() {
            response.isDeleted = true;
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    } else {
      return new Promise(function(resolve, reject) {
        response.error = "User with Id" + model.Id + " not found";
        reject(response);
      });
    }
  }

  getCollectionName() {
    console.log(this.collectionName);
  }

  async writeUsersData() {
    //var count = 0;
    var response = { isCommitted: false, error: "" };
    let count = await this.getUsersCount();
    //console.log(count);

    if (count == 0) {
      //create new static data for users
      // Get a new write batch
      var batch = db.batch();

      for (const key in this.staticUsers) {
        if (this.staticUsers.hasOwnProperty(key)) {
          const element = this.staticUsers[key];
          var nycRef = db.collection(this.collectionName).doc(key);
          batch.set(nycRef, { element });
        }
      }
      //console.log(batch);

      return new Promise(function(resolve, reject) {
        // Commit the batch
        batch
          .commit()
          .then(function() {
            response.isCommitted = true;
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    }
  }

  getUsersCount() {
    var usersCollection = db.collection(this.collectionName);
    var count = 0;
    return new Promise(function(resolve, reject) {
      usersCollection
        .get()
        .then(function(querySnapshot) {
          if (querySnapshot.empty) count = 0;
          count = querySnapshot.size;
          resolve(count);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }
}

export default new UserStore("users");
